module.exports = __webpack_public_path__ + "static/media/daisie-avatar.14428a28.jpg";